import React, { Component, Fragment, useEffect, useState, useRef } from 'react';
import Configurator from "../../Components/ProductPage/Configurator";
import SuperBuilder from '../../Components/ProductPage/SuperBuilder';
import BuySection from '../../Components/ProductPage/BuySection';
import { translate } from '../../Services/translation';
import MultiCarousel from '../MultiCarousel';
import LightboxImages from '../../Components/ProductPage/LightboxImages';
import { load as loadCartAction, hint as hintCart } from '../../Actions/Cart.action'; // Ändrad till loadCartAction för att undvika krock
import StringBuilder from '../../Components/StringBuilder';
import FavoriteIcon from '../../Components/FavoriteIcon';
import ProductInformation from './ProductInformation';
import BrandInfo from './BrandInfo';
import MultiCarouselProduct from '../MultiCarouselProduct';
import { culture } from '../../Services/culture';
import SliderImages from './SliderImages';
import { useDispatch } from 'react-redux';
import { pushProductPageEvent } from '../../Actions/Gtm.action';
import FeatureList from '../FeatureList';
import StockStatus from '../StockStatus';
import { useSelector } from "react-redux";
import { motion } from "framer-motion";

const Product = (props) => {
    const dispatch = useDispatch();      

    const [product, setProduct] = useState([]);
    const [imageItems, setimageItems] = useState([]);
    const [productFieldValue, setProductFieldValue] = useState([]);
    const [isSuperBuilderActive, setisSuperBuilderActive] = useState(false);
    const [isConfiguratorActive, setisConfiguratorActive] = useState(false);
    const [selectedKeys, setselectedKeys] = useState([]);
    const [quantity, setquantity] = useState(0);
    const [selectedOptions, setselectedOptions] = useState([]);   
    const [reloadChildComponent, setreloadChildComponent] = useState(false);
    const [reloadConfigurator, setreloadConfigurator] = useState(false);
    const [recommendedProducts, setRecommendedProducts] = useState([]);
    const [brandPage, setBrandPage] = useState({});
    const [showAllColorFilter, setShowAllColorFilter] = useState(false);
    const INITIAL_COUNT = 3;  
    const [colorFilterItems, setColorFilterItems] = useState([]);
    const colorListRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [stockStatusData, setStockStatusData] = useState({});

    let productInformationVisible = false;
    let productSpecificationVisible = false;
    let productOthersVisible = false;
    let images = [];
    let optionNames = props.optionNames;

    let campaignClass = "product-detail__campaign-label";    
    const lightBoxImageState = useSelector((state) => state.lightboxImages);
    const isLightboxOpen = lightBoxImageState?.visible;

    // Set initial mandatory section id for scroll    
    const getNonSelectedMandatorySectionId = (sections) => {
        const mandatorySections = sections.filter(x => x.isMandatory);
        if (mandatorySections) {
            const mandatorySectionWithNoSelection = mandatorySections.find(section => section.userSelected === false);
            return mandatorySectionWithNoSelection ? mandatorySectionWithNoSelection.id : "";
        }
    }

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    useEffect(() => {           
        ChangeProduct(props.product, false);
    }, []);

    useEffect(() => {            
        if (props.superBuilderJsonData == undefined) {
            return;
        }

        if (props.selectedCombinedConfiguratorKeys) {
            updatePriceBetweenComponenets(props.selectedCombinedConfiguratorKeys, true)
        }
    }, [props]);

   useEffect(() => {
        if (product && product?.productItem?.id) {
            GetProductImageUrls();
            setProductFieldValue(product.productFieldValue);
            dispatch(pushProductPageEvent(product.productItem.id));

            let superBuilderHasData = product.superBuilderJsonData != null && product.superBuilderJsonData != "";
            let superBuilderHasSections = superBuilderHasData ? JSON.parse(product.superBuilderJsonData).sections.length > 0 : false;

            let configuratorHasData = product.productConfiguratorJsonData != null && product.productConfiguratorJsonData != "";
            let configuratorHasSections = configuratorHasData ? JSON.parse(product.productConfiguratorJsonData).sections.length > 0 : false;

            if (configuratorHasSections && superBuilderHasSections) {
                let superBuilderData = JSON.parse(product.superBuilderJsonData);
                let nonSelectedMandatorySectionId = getNonSelectedMandatorySectionId(superBuilderData.sections);
        
                let configData = JSON.parse(product.productConfiguratorJsonData);
                configData.nonMandatorySectionNotSelectedId = nonSelectedMandatorySectionId;
                product.productConfiguratorJsonData = JSON.stringify(configData);
            }

            setquantity(product.packagingQuantity);
            setisConfiguratorActive(configuratorHasSections);
            setisSuperBuilderActive(superBuilderHasSections);    
            
            if (product.colors) {                
                const sorted = [...product.colors].sort((a, b) => {
                    const aSelected = a.id === product?.productItem?.id;
                    const bSelected = b.id === product?.productItem?.id;
                    return bSelected - aSelected; 
                });
                setColorFilterItems(showAllColorFilter ? sorted : sorted.slice(0, INITIAL_COUNT));                 
            } 
        }
    }, [product]);

    useEffect(() => {
        if (product.colors) {
            const sorted = [...product.colors].sort((a, b) => {
                const aSelected = a.id === product?.productItem?.id;
                const bSelected = b.id === product?.productItem?.id;
                return bSelected - aSelected;
            });

            if (showAllColorFilter) {
                setColorFilterItems(sorted);
            } else {
                setColorFilterItems(sorted.slice(0, INITIAL_COUNT)); 
            }
        }        
    }, [showAllColorFilter]);

    useEffect(() => {
        setreloadChildComponent(!reloadChildComponent);
    }, [quantity]);

    const updatePriceBetweenComponenets = (selectedCombinedKeys, updateSB, firstIteration, currentSelectedOptions, currentQuantity, nonMandatorySectionNotSelectedId, quantityUpdate = false) => {
        if (updateSB) {
            if (selectedCombinedKeys == null) {
                setquantity(currentQuantity);                
                return;
            }
            var superBuilderData = JSON.parse(product.superBuilderJsonData);

            superBuilderData.sections.forEach(s =>
                s.variants.forEach((v) => {
                    for (var i = 0; i < selectedCombinedKeys.length; i++) {
                        if (selectedCombinedKeys[i].key === v.key) {
                            v.selected = true;
                            v.quantity = selectedCombinedKeys[i].quantity;
                        }
                    }
                }));

            let index = 0;
            var configData = JSON.parse(product.productConfiguratorJsonData);
            configData.sections.forEach(section => {
                section.options.forEach(o => {
                    for (var i = 0; i < selectedCombinedKeys.length; i++) {
                        if (selectedCombinedKeys[i].value.includes(o.key) && currentSelectedOptions && currentSelectedOptions.includes(getSelectedOptionName(o))
                            && currentSelectedOptions.length !== index) {
                            o.selected = true;
                            index++;
                        }
                        else {
                            o.selected = false;
                        }
                    }
                });
            });

            superBuilderData.selectedCombinedKeys = selectedCombinedKeys;
            let tempProductData = product;

            tempProductData.superBuilderJsonData = JSON.stringify(superBuilderData);
            setselectedOptions(currentSelectedOptions);
            setProduct(tempProductData);
        }
        else {
            if (product.productConfiguratorJsonData && product.productConfiguratorJsonData !== "") {
                var configData = JSON.parse(product.productConfiguratorJsonData);

                configData.sections.forEach(s => {
                    s.options.forEach((o) => {
                        if (firstIteration) {
                            o.selected = true;
                            firstIteration = false;
                            if (o.key != null) {
                                for (var i = 0; i < selectedCombinedKeys.length; i++) {
                                    selectedCombinedKeys[i].value.push(o.key);
                                }
                            }
                        }
                        else if (currentSelectedOptions && currentSelectedOptions.includes(getSelectedOptionName(o))) {
                            o.selected = true;
                            s.userSelected = true;
                        }
                        else {
                            o.selected = false;
                        }
                    });
                });

                if (nonMandatorySectionNotSelectedId && nonMandatorySectionNotSelectedId !== "") {
                    configData.nonMandatorySectionNotSelectedId = nonMandatorySectionNotSelectedId;
                }

                configData.selectedCombinedKeys = selectedCombinedKeys;
                let tempProductData = product;
                tempProductData.productConfiguratorJsonData = JSON.stringify(configData);
                setProduct(tempProductData);
            }
            else {
                var superBuilderData = JSON.parse(product.superBuilderJsonData);
                superBuilderData.selectedCombinedKeys = selectedCombinedKeys;

                let tempProductData = product;
                tempProductData.superBuilderJsonData = JSON.stringify(superBuilderData);
                setProduct(tempProductData);
            }

            if (!quantityUpdate) {
                setreloadConfigurator(!reloadConfigurator);
            }            
        }        
    }

    const getSelectedOptionName = (option) => {
        if (option) {
            if (option.additionalInfo && option.additionalInfo.row2) {
                return `${option.name} -  ${option.additionalInfo.row2}`;
            }
            else {
                return option.name;
            }
        }
    }

    const GetFilterItem = (item, uniqueImages) => {
        const isSelected = item.id === product?.productItem?.id;
        return (
            <motion.li 
                layout 
                transition={{ 
                    type: "spring",   
                    stiffness: 250,  
                    damping: 28 
                }}
                className={`configurator-variants__item-product ${isSelected ? "active" : ""}`} 
                onClick={() => ChangeProduct(item.id, true)}  
                key={item.id} 
                value={item.id}
            >
            {item.variantImage != null && 
                <div                         
                    className={`${item.enabled ? "" : "unavailable"} configurator-variants__img-container`}
                    dangerouslySetInnerHTML={{ __html: item.variantImageUrl }} 
                ></div>
            }
                {isSelected && (
                    <span className="check-icon"></span>
                )}
                <div className="configurator-variants__name-container">  
                    <div className="configurator-variants__name">
                        <p>{item.title}</p>
                    </div>      
                    <div className="configurator-variants__price-container">
                        {item.priceFormatted != null && item.priceFormatted != "" &&
                            <div className="configurator-variants__price">
                                {item.configuratorPrefix} {item.priceFormatted}
                            </div>
                        }
                        {item.priceOriginalFormatted &&
                            <div className="configurator-variants__original-price">
                                {item.configuratorPrefix} {item.priceOriginalFormatted}
                            </div>
                        }
                        {item.stockText &&
                            <div className="configurator-variants__stock-text">
                                {item.stockText}
                            </div>
                        }
                    </div>            
                </div>
            </motion.li> 
        )
    }

    const GetFilterItemAsOption = (item, uniqueImages) => {
        return (
            <option key={item.id} value={item.id}>{item.title}                
            </option>
        )
    }

    const GetProductImageUrls = () => {
        var imageItemsData = product.productItem.lightBoxLazyLoadImagesUrl;

        if (product.productItem.youTubeLink != null && product.productItem.youTubeLink != "") {
            let thumbnailItemYoutube = {
                "src": "/ui/images/tibergs-svg/play.svg"
            };
            let itemsYoutube = {
                "src": product.productItem.youTubeLink,
                "iframe": 'true',
                "view360": 'false',
                "thumbnail": thumbnailItemYoutube
            };
            imageItemsData.push(itemsYoutube);
        }

        setimageItems(imageItemsData);
    }

    const ChangeProduct = (Id, changeVariant) => {
        let targetY = null;
        if (changeVariant && colorListRef.current) {
            targetY = colorListRef.current.getBoundingClientRect().top + window.pageYOffset - 140;
        }

        fetch("/api/product/getselectedproduct?variantId=" + Id + "&isMobile=" + props.isMobileDevice + "&changeVariant=" + changeVariant , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'litium-request-context': JSON.stringify(__litium.requestContext)
            },
            redirect: 'follow'
        })
        .then(response => response.json())
        .then(result => {
            if (result != null) {                    
                var productModel = result;                                                                                                                                                
                document.title = translate('seotitle.productpage').replace("{Product name}", productModel?.productItem?.name)
                .replace("{Product brand}", productModel.productItem.brand);
                
                setProduct(productModel);                    
                setProductFieldValue(productModel.productFieldValue);

                if (changeVariant) {
                    setShowAllColorFilter(false);
                }

                if (productModel.stockStatusJsonData) {
                    setStockStatusData(JSON.parse(productModel.stockStatusJsonData));
                }

                if (!changeVariant) {
                    setRecommendedProducts(result.recommendedProducts);
                    setBrandPage(result.brandPage);
                }

                var blockBrandElement = document.getElementById("product-block-brand");
                if (blockBrandElement) {
                    blockBrandElement.setAttribute("style", "display: block;");
                }

                if (targetY !== null) {
                    if (window.pageYOffset > targetY) {
                        setTimeout(() => {
                            window.scrollTo({
                                top: targetY,
                                behavior: 'smooth'
                            });
                        }, 200);
                        
                    }
                }
            }
        })
        .catch(error => console.log('error', error));
    }


    const handleLoadCart = (data) => {
        dispatch(loadCartAction(data));
    }

    const hintAddedItem = (articleNumber) => {
        dispatch(hintCart(true, articleNumber))
        setTimeout(() => {
            dispatch(hintCart(false, articleNumber))
        }, 2000);
    }

    return (
        <Fragment>
            {product && product?.productItem?.id && <>
                <div className="product-detail">
                    <div className="product-detail__inner">                        
                        <div className="product-detail__images">
                            <div className={`product-detail__image-gallery ${isLightboxOpen ? 'lightbox-open' : ''}`}>
                                {((product.productItem.charpter3DLinkIOS !== null && product.productItem.charpter3DLinkIOS !== "")
                                    || (product.productItem.charpter3DLinkAndroid !== null && product.productItem.charpter3DLinkAndroid !== "")) &&
                                    <div className={(product.productItem.newsSvg !== null && product.productItem.newsSvg !== "")
                                        || (product.productItem.campaignSvg !== null && product.productItem.campaignSvg !== "")
                                        ? "product-detail__charpster-container" : "product-detail__charpster-container-top"}>
                                        <charpstar-container data-language="sv-se" data-position="bottom-right" style={{ display: 'none' }}>
                                            <button data-tech="charpstar-ar">{translate("product.charpstar.viewinAR")}</button>
                                            <button data-tech="charpstar-3d">{translate("product.charpstar.viewin3D")}</button>
                                        </charpstar-container>
                                    </div>
                                }
                                {product.productItem.images != null && product.productItem.images.length > 0 ?
                                    <div>
                                        <LightboxImages images={imageItems} isAmbiance={product.productItem.adjustEnvironmentalImageBackground}
                                            thumbnails={imageItems.map((item) => (item.thumbnail))}></LightboxImages>
                                    </div> : <span className="product-detail__image-missing">{translate('product.noproductimage')}</span>}
                            </div>
                            {/* {product.productItem != null && product.productItem.additionalImages != null && product.productItem.additionalImages.length > 0 &&
                                <div className="product-detail__additional-images">
                                    {product.productItem.additionalImagesUrl.map((item, index) => (
                                        <div dangerouslySetInnerHTML={{ __html: item }} key={index} />))}
                                </div>} */}
                        </div>
                        <input type="hidden" id="hdnItemUrl" value={product.productItem.urlFieldData} />
                            <div className={'product-detail__product-selector' + (product.productInfoMessage ? ' has-message' : '')}>
                                <div className="product-detail__header-container">    
                                    {product.productItem.newsSvg != null && product.productItem.newsSvg != ""
                                        ? <div className={`product-detail__news`}
                                            style={{
                                                color: product.productItem.newsLabelColor,
                                                backgroundColor: product.productItem.newsLabelBackgroundColor
                                            }}>{translate("general.newslabeltext")}
                                        </div>
                                        :
                                        product.productItem.campaignSvg != null && product.productItem.campaignSvg != "" && !product.productItem.newsSvg &&
                                        <div className={`${product.productItem.campaignPercentage > 0 ? `${campaignClass} product-detail__campaign-percentage` : "product-detail__campaign-text"}`}
                                            style={{
                                                color: product.productItem.campaignPercentageColor,
                                                backgroundColor: product.productItem.campaignPercentageBackgroundColor
                                            }}>
                                            {product.productItem.campaignPercentage > 0 ? `${product.productItem.campaignPercentage}%` : translate("general.campaignlabeltext")}</div>
                                    }    
                                    <div className="product-detail__name-and-favorite">
                                        <h1 className="product-detail__name as-h2">{product.productItem.name}</h1>       
                                        <FavoriteIcon articleNumber={product.productItem.baseProductId != "" ? product.productItem.baseProductId : product.productItem.id}></FavoriteIcon>                     
                                    </div>                    
                                    {product.productItem.brand && product.brandPage &&
                                        <div className="product-detail__brand">
                                            <p style={{ margin: 0 }}>{translate('product.brand')}: <a href={product.brandPage.brandUrl}> <span>{product.productItem.brand}</span></a></p>                                    
                                        </div>
                                    }
                                    {product.productItem.brand && !product.brandPage &&
                                        <div className="product-detail__brand">
                                            <p style={{ margin: 0 }}>{translate('product.brand')}: <span>{product.productItem.brand}</span></p>                                    
                                        </div>
                                    }
                            </div>                            
                            <div className="product-detail__select-and-buy">
                                {product.superBuilderJsonData !== null && product.superBuilderJsonData !== "" ?
                                    <SuperBuilder key={product.selectedVariant.id + reloadChildComponent} parent={product.selectedVariant} superBuilder={product.superBuilderJsonData}
                                        prices={product.productConfiguratorPricesJsonData} comment={product.comment} updatePrice={updatePriceBetweenComponenets}
                                        quantity={Number(quantity)} isConfiguratorActive={isConfiguratorActive} />
                                    :
                                    <ul className={"product-selector " + (product.productConfiguratorJsonData != null && product.productConfiguratorJsonData != "" ? " product-selector--variant-select" : "")}>
                                        {colorFilterItems.length > 1 &&
                                            <li key={product.colorText}>
                                                <div className="product-selector__header">                                                                                    
                                                    <div className="product-selector__name">
                                                        <span className="bold">{product.colorText}</span>
                                                        <span>{product.colors.find(x => x.isActive) ? product.colors.find(x => x.isActive).title : product.colors[0].title}</span>
                                                    </div>
                                                </div>
                                                <div className="product-selector__content">
                                                    <ul className="configurator-variants" data-filter="colorfilter" id="colorfilter" ref={colorListRef}>
                                                        {colorFilterItems.map((color) => (GetFilterItem(color, product.uniqueImage)))}
                                                        {product.colors.length > INITIAL_COUNT && (
                                                            <button 
                                                                className={showAllColorFilter ? "button__open" : "button__close"}
                                                                onClick={() => setShowAllColorFilter(!showAllColorFilter)}
                                                                >
                                                                {showAllColorFilter 
                                                                    ? translate("product.variant.showless") 
                                                                    : `${translate("product.variant.showmore")} +${product.colors.length - INITIAL_COUNT}`
                                                                }
                                                                <svg className="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                                                            </button>
                                                        )}
                                                    </ul>
                                                </div>
                                            </li>
                                        }
                                        {product.sizes != null && product.sizes.length > 1 && (
                                            <li key={product.sizeText}>
                                                <div className="product-selector__header">                                                                                                                        
                                                    <div className="product-selector__name">
                                                        <span className="bold">{product.sizeText}</span>
                                                    </div>
                                                </div>
                                                <div className="product-selector__content">
                                                    <div ref={dropdownRef} className="custom-dropdown-wrapper" style={{ position: 'relative' }}>
                                                        <button 
                                                            type="button"
                                                            className="configurator-variants" 
                                                            id="sizefilter" 
                                                            data-filter="sizefilter"
                                                            onClick={() => setIsOpen(!isOpen)}
                                                        >
                                                            {(() => {
                                                                const activeSize = product.sizes.find(x => x.isActive) || product.sizes[0];
                                                                const optionElement = GetFilterItemAsOption(activeSize, false);
                                                                return optionElement ? optionElement.props.children : '';
                                                            })()}
                                                        </button>
                                                         <span className={`dropdown-arrow ${isOpen ? 'arrow-up' : 'arrow-down'}`}>
                                                            <svg className="svg-arrow"><use href="/ui/images/tibergs-svg/sprite/sprite.svg#arrow-right"></use></svg>
                                                        </span>
                                                        {isOpen && (
                                                            <ul className="custom-dropdown-options">
                                                                {product.sizes.map((size) => {
                                                                    const optionElement = GetFilterItemAsOption(size, false);
                                                                    if (!optionElement) return null;
                                                                    const displayLabel = optionElement.props.children;
                                                                    const optionId = optionElement.props.value; 
                                                                    const isActive = size.isActive || product.sizes[0].id === size.id;

                                                                    return (
                                                                        <li 
                                                                            key={size.id || optionId}
                                                                            className={`custom-dropdown-item ${isActive ? 'is-active' : ''}`}
                                                                            onClick={() => {
                                                                                ChangeProduct(optionId, true); 
                                                                                setIsOpen(false); 
                                                                            }}
                                                                        >
                                                                            {displayLabel}
                                                                        </li>
                                                                    );
                                                                })}
                                                            </ul>
                                                        )}
                                                    </div>
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                }

                                {product.productConfiguratorJsonData != null && product.productConfiguratorJsonData != "" ?
                                    <Configurator key={product.selectedVariant.id + reloadConfigurator} parent={product.selectedVariant} 
                                        configurator={product.productConfiguratorJsonData}
                                        prices={product.productConfiguratorPricesJsonData} stockstatus={product.stockStatusJsonData}
                                        stockInfoMessage={product.stockInfoMessage} comment={product.comment}
                                        packagingQuantity={Number(product.packagingQuantity)}
                                        featureList={product.featureList} productInfoMessage={product.productInfoMessage} updatePrice={updatePriceBetweenComponenets}
                                        isSuperBuilderActive={isSuperBuilderActive} lowestPrice30Days={product.productItem.lowestPrice30Days} 
                                        campaignRemainingDays={product.productItem.campaignRemainingDaysText} 
                                        campaignRemainingDaysDesc={product.productItem.campaignRemainingDaysDescription} variantSystemId={product.selectedVariant.systemId} 
                                        deliveryInformation={product.productItem.deliveryInformation}
                                         />
                                    :
                                    <BuySection title={product.recommendedAccessoriesTitle} article={product.productItem.id} price={product.price}
                                        campaignPrice={product.campaignPrice}
                                        accessories={product.recommendedAccessories.value} comment={product.comment}
                                        stockInfoMessage={product.stockInfoMessage} packagingQuantity={Number(product.packagingQuantity)}
                                        productInfoMessage={product.productInfoMessage} bundleProducts={JSON.parse(product.bundleProductsList)}
                                        featureList={product.featureList} hintAddedItem={hintAddedItem} loadCart={handleLoadCart} // Ändrad här till handleLoadCart
                                        parent={product.selectedVariant} superBuilder={product.superBuilderJsonData} lowestPrice30Days={product.productItem.lowestPrice30Days} 
                                        campaignRemainingDays={product.productItem.campaignRemainingDaysText} stockstatus={stockStatusData}
                                        campaignRemainingDaysDesc={product.productItem.campaignRemainingDaysDescription} variantSystemId={product.selectedVariant.systemId}
                                        key={product.productItem.id}
                                         />
                                }

                                {(product.productConfiguratorJsonData === null || product.productConfiguratorJsonData === "") && <div className="buy-box__info">
                                    <StockStatus data={JSON.parse(product.stockStatusJsonData)} deliveryInformation={product.productItem.deliveryInformation}></StockStatus>                    
                                </div>}

                                {product.featureList && product.featureList.length > 0 && (stockStatusData ? !stockStatusData.onlyInStore : true) && (
                                    <div className="product-detail__feature-list"> 
                                        <FeatureList featureList={product.featureList} includeLink={true}/>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <ProductInformation
                    informationTemplate={product.informationTemplate}
                    productFieldValue={productFieldValue}
                    detailedSpecification={product.detailedSpecification}
                    productDescription={product.productItem.productDescription}
                />

                {
                    product.stringBuilderGuid !== null && product.stringBuilderGuid !== "" && brandPage !== null &&
                    <div id="string-builder">
                        <StringBuilder guid={product.stringBuilderGuid} stringImageHtml={brandPage.stringImageHtml}
                            textColor={brandPage.textColor} countryCode={product.countryCode}/>
                    </div>
                }

                {
                    product.mostSoldProducts != null && product.mostSoldProducts.length > 1 &&
                    <div className="row">
                        <div className="small-12 columns">

                            {product.productItem.name != null && product.productItem.name != "" &&
                                <h2 className="product-detail__header-title" dangerouslySetInnerHTML={{ __html: translate("product.popularproducts") }}>
                                </h2>
                            }
                            {(product.productItem.name == null || product.productItem.name == "") &&
                                <h2 className="product-detail__header-title">{translate('product.mostsoldproducts')}</h2>
                            }
                            <div className="row most-sold-container">
                                {product.mostSoldProducts.map((item, index) => {
                                    return (
                                        <div key={index} className="product-list__item columns small-6 medium-4 large-3">
                                            <MultiCarouselProduct item={item} index={index} />
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                }
                {
                    product.accessoriesProducts != null && product.accessoriesProducts.value.length > 0 &&
                    <section className="row-container bg--beige no-print">
                        <div className="row bg-padding">
                            <div className="small-12 columns">
                                <div>

                                    <h3 className="product-detail__header-pre-title pre-header-list">{translate('common.selectedforyou')}</h3>
                                    <h2 className="product-detail__header-title header-list">
                                        {product.accessoriesProducts.key.fields._name[culture]}
                                    </h2>
                                    <div className="product-detail__item-container">
                                        <div className="row multi-carousel-style">
                                            <MultiCarousel items={JSON.parse(product.similarProductsJson)} itemType="product" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                }

                {
                    recommendedProducts && recommendedProducts.map((products, index) => (
                        products.recommendedProducts &&
                        <Fragment key={`recommendedproducts-${products.id}-${index}`}>
                            <div className="block-container no-print product-detail__recommended-products-block">
                                <div className="row block-heading">
                                    <h2 className="columns small-12 header-list">{products.title}</h2>
                                </div>
                                <div className="row multi-carousel-style">
                                    <MultiCarousel items={(products.recommendedProducts)} itemType="product" />
                                </div>
                            </div>
                        </Fragment>
                    ))
                }                
            </>}
        </Fragment>
    )
}

export default Product;